/**
 * Integrytas Group - Base App (MOBILE)
 * Generic mobile scaffold — the fallback screen for any page_internal_code that
 * does not yet have a bespoke mobile-native component in MOBILE_PAGE_COMPONENTS.
 *
 * Every registered page is therefore routable on mobile: bespoke screens render
 * their real UI, all others render this clean, intentional shell. This is what
 * makes toggling a page's `desktop_only` flag OFF "just work" — the route already
 * resolves to a live screen; upgrading it to a full mobile-native page is a
 * drop-in replacement of the registry entry (§16, task phase 3).
 *
 * It reads no data of its own (it can't know the entity generically); a real
 * screen wired through apiDb + the Common Routine replaces it per page.
 */

import { useTranslation } from 'react-i18next';
import { LayoutGrid, Sparkles } from 'lucide-react';

export interface MobileScaffoldPageProps {
  code: string;
  title?: string;
  route?: string;
}

export function MobileScaffoldPage({ code, title, route }: MobileScaffoldPageProps) {
  const { t } = useTranslation();
  return (
    <section className="m-screen">
      <div className="m-scaffold-hero">
        <span className="m-scaffold-ic"><LayoutGrid /></span>
        <span className="m-scaffold-tt">
          <span className="m-scaffold-t">{title || code}</span>
          <span className="m-scaffold-s">{route || code}</span>
        </span>
      </div>
      <div className="m-card">
        <div className="m-scaffold-note">
          <Sparkles />
          <span>
            {t('mobile.scaffold.body', 'This screen is available on mobile. Its streamlined mobile layout is being finalized — the full feature set remains available on the desktop app.')}
          </span>
        </div>
      </div>
    </section>
  );
}
